/**
 * 文件预览demo
 */
import React from 'react';
// import QrCode from '../customComponent/QrCode';
import http from '../../../axios/http.js';
import {getUrlParam} from '../../../util/util.js';
//加载中遮罩
import Loading from '../../ui/Loading';


class ImgDemo extends React.Component {

    state = {
        // imgList: ["https://app.xm2auto.com:8888/mall/common/getWatermarkImage?imagePath=/opt/tc/images/mall/vehicle/202005/125/leftFront.jpg"
        //     , "https://app.xm2auto.com:8888/mall/common/getWatermarkImage?imagePath=/opt/tc/images/mall/vehicle/202005/127/leftFront.jpg"
        // ] 
        imgList: [],
        loadingVisible: false
    }

    componentDidMount() {
        let id = getUrlParam("id");
        this.setState({ loadingVisible: true });
        http.get({
            url: '/exportCheckReport/get',
            data: { id: id },
            success: (res) => {
                //原图方案，暂时停用
                //let vehicleImages=JSON.parse(res.photos)
                let vehicleImages=res.otherImages;
                //原图方案，暂时停用
                //let url = "/common/image";
                let imageUrls = [];
                if ( vehicleImages !== null && vehicleImages.length > 0) {
                    vehicleImages.forEach((item, index) => {
                        //原图方案，暂时停用
                        // imageUrls.push('https://app.xm2auto.com:8888' + url + "?imagePath=" + encodeURI(item));  //server.httpServerUrl  
                        imageUrls.push("data:image/jpeg;base64," + item.replace(/\r\n/g, ""));
                    });
                }
                this.setState({ 
                    imgList: imageUrls
                });
                this.setState({ loadingVisible: false });
                // this.initEdit(res);
                this.showModal();
            },
            error: () => {
                this.setState({ loadingVisible: false });
            }
        });


        
    }

    render() {
        const { imgList } = this.state;
        return (
            <div style={{ width: '100%',height:'100%', overflow:'scroll' }}>
                {/* <QrCode
                    value='https://www.baidu.com'  //value参数为生成二维码的链接
                    size={200} //二维码的宽高尺寸
                    fgColor="#000000"  //二维码的颜色
                /> */}

                {imgList.map((item, index) => {
                    return (<div key={index} >
                        <img style={{width: '100%'}} src={item} alt=""></img>
                    </div>);
                })}
                <Loading
                    visible={this.state.loadingVisible}
                    message="图片加载中"
                />
            </div>
            
        )
    }
}


export default ImgDemo;